module.exports = __webpack_public_path__ + "img/classes_cards.cc3236e7.png";